import { NEW_ADMIN_INVOICES_AR } from 'App/featuresFlags';
import { useGetCountry, useGetTags } from 'domains/Auth/hooks';

function useShowTaxExceptionsCard(): boolean {
  const country = useGetCountry();
  const tags = useGetTags();
  const isAr = country === 'AR';
  const hasTaxExceptionCard = isAr && tags.includes(NEW_ADMIN_INVOICES_AR);

  return hasTaxExceptionCard;
}

export default useShowTaxExceptionsCard;
